import { ESSLRecord } from '../../../../api/types/subscription';

export const ESSL_RECORDS_ACTIONS = {
  CLUEY_PLUS_SIGNUP: 'ClueyPlus Signup',
  CLUEY_PLUS_APPLY_DISCOUNT: 'ClueyPlus Apply Discount',
  CLUEY_PLUS_TRIAL_CONVERSION: 'ClueyPlus Trial Conversion',
  CLUEY_PLUS_CANCEL: 'ClueyPlus Cancel',
  CLUEY_PLUS_BUNDLE_SIGNUP: 'ClueyPlus Bundle Signup',
};

export const ESSL_RECORDS_STATUS = {
  PROCESSING: 'Processing',
  PROCESSED: 'Processed',
  ERROR: 'Error',
};

export class ESSLRecordHelper {
  static hasRecordAction(esslRecords: ESSLRecord[], action: string) {
    return esslRecords.some((record) => record.actionC === action);
  }

  static hasRecordStatus(esslRecords: ESSLRecord[], status: string) {
    return esslRecords.some((record) => record.statusC === status);
  }

  static getRecordByAction(esslRecords: ESSLRecord[], action: string) {
    return esslRecords.find((record) => record.actionC === action);
  }

  static getRecordByStatus(esslRecords: ESSLRecord[], status: string) {
    return esslRecords.find((record) => record.statusC === status);
  }

  static getRecordByStatusAndAction(esslRecords: ESSLRecord[], status: string, action: string) {
    return esslRecords.find((record) => record.statusC === status && record.actionC === action);
  }

  static getLatestRecordByStatus(esslRecords: ESSLRecord[], status: string) {
    return esslRecords
      .sort((a, b) => new Date(b.createddate).getTime() - new Date(a.createddate).getTime())
      .find((record) => record.statusC === status);
  }
}
